<template>
  <div class="table-settings">
    <div
      class="table-settings__icon"
      @click.stop="iconClickHandler"
      v-html="IcSettings"
    />
    <q-popup-proxy v-model="opened" :value="opened">
      <div class="table-settings__popup">
        <div class="table-settings__title">
          Настройки
        </div>

        <div class="table-settings__menu-items">
          <div
            v-for="(menuItem, index) in menuItems"
            :key="index"
            class="table-settings__menu-item"
          >
            <input
              v-model="menuItem.hidden"
              class="table-settings__checkbox"
              type="checkbox"
              @input="updateMenuItem(menuItem)"
            >
            <div
              class="table-settings__label"
              @click="updateMenuItem(menuItem)"
            >
              {{ menuItem.label }}
            </div>
          </div>
        </div>

        <div
          class="table-settings__settings-reset"
          @click="$emit('reset-settings')"
        >
          Сбросить настройки
        </div>
      </div>
    </q-popup-proxy>
  </div>
</template>

<script>
/**
 * Компонент с настройками таблицы
 * @module Shared/Component/Table/Settings
 * @requires Images/icon/ic-settings.svg
 * @vue-prop {Array} config - конфигурация таблицы
 * @vue-data {Boolean} opened - открыт ли popup настроек
 * @vue-computed {Array} menuItems - настраиваемые элементы
 * */

import IcSettings from 'Images/icon/ic-settings.svg'

export default {
  name: 'TableSettings',
  props: {
    config: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    opened: false,
    IcSettings
  }),
  computed: {
    menuItems() {
      const result = []
      this.config.forEach(configElement => {
        if (!configElement.extandable) {
          result.push({
            label: configElement.title,
            hidden: !configElement.hidden,
            field: configElement.field
          })
        }
      })
      return result
    }
  },
  methods: {
    /**
     * Обработчик клика по иконке настроек
     */
    iconClickHandler() {
      this.opened = !this.opened
    },
    /**
     * Создать событие на обновление настроек колонок
     * @param {Object} menuItem - изменяемый элемент меню
     */
    updateMenuItem(menuItem) {
      this.$emit('update-column', {
        paramName: 'hidden',
        columnName: menuItem.field,
        value: menuItem.hidden
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-settings {
  position: relative;

  &__icon {
    width: 24px;
    height: 24px;

    cursor: pointer;
  }

  &__popup {
    bottom: 30px;
    padding: 15px;

    background-color: white;
    border: 1px solid black;
    border-radius: 5px;
  }

  &__title {
    font-size: 20px;
    font-weight: 600;

    margin-bottom: 10px;
  }

  &__menu-items {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-height: 160px;

    padding-bottom: 5px;

    overflow-x: auto;
  }

  &__menu-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 3px;
    margin-left: 5px;
  }

  &__menu-item:last-child {
    margin-bottom: 0;
  }

  &__label {
    white-space: nowrap;

    cursor: pointer;
  }

  &__checkbox {
    margin-right: 5px;
  }

  &__settings-reset {
    margin-top: 15px;

    white-space: nowrap;
    color: gray;
    font-size: 12px;

    width: fit-content;

    cursor: pointer;
  }
}
</style>
